import { type FC } from "react";
import { generatePath, useParams } from "react-router-dom";

import { AbsoluteRoute, type RouteParams } from "../../core/routes";
import { RouteEntities } from "../../core/routes/relativeRoutes";
import { useSelectedOrganizationContainer } from "../../shared/hooks";
import { LinkStyled, linkButtonElevatedClassName } from "../../shared/styles";
import { useLensIdSearchParameter } from "../hooks";

import { LensDetailsButtonText } from "./messages.generated";

export const LensDetailsButtonV3: FC = () => {
    const { lensId } = useLensIdSearchParameter();
    const { insightsTab } = useParams<RouteParams[AbsoluteRoute.ORG_LENS_FOLDER_INSIGHTS_TAB]>();

    const { orgId, lensFolderId } = useSelectedOrganizationContainer();
    if (!lensId || insightsTab === RouteEntities.Monetization) {
        return null;
    }

    return (
        <LinkStyled
            to={generatePath(AbsoluteRoute.ORG_LENS_FOLDER_LENS, {
                orgId: orgId ?? "",
                lensFolderId: lensFolderId ?? "",
                lensId,
            })}
            className={linkButtonElevatedClassName}
            data-testid="lens-details-link"
        >
            <LensDetailsButtonText />
        </LinkStyled>
    );
};
